<template>
    <div v-if="$route.name == 'searchthird'">
      <div
        class="container-fluid"
        style="background-color: rgb(221,221,221);"
      >
        <div
          class="container"
          style="display: flex;align-items: center;color: black;line-height: 30px;margin-bottom: 30px;"
        >
          <div
            class="row"
            style="width: 100%;"
          >
            <div
              class="col-xs-12 col-sm-12 col-md-4"
              style="margin-top: 30px;"
            >
              <div>
                {{ $t("message.i18n_5") }}：河北公博
              </div>
              <div >
                {{ $t("message.i18n_6") }}：18033725619  15810985449
              </div>
              <div>
                {{ $t("message.i18n_8") }}：河北省石家庄市桥西区建设南大街6号西美写字楼11楼1101室
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-4 col-md-2"
              :class="$store.state.languageVuex == 'en'? 'col-md-2' : 'col-md-1'"
              v-if="menuList.length > 0"
              style="margin-top: 30px;"
            >
              <div
                style="cursor: pointer;"
                @click="toUrl(menuList[0])"
              >
                {{menuList[0].title}}
              </div>
              <div v-for="(item,index) in menuList[0].children">
                <span
                  style="cursor: pointer;"
                  @click="toUrl(item)"
                >{{item.title}}</span>
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-6 col-md-2"
              v-if="menuList.length > 1"
              style="margin-top: 30px;"
            >
              <div
                style="cursor: pointer;"
                @click="toUrl(menuList[1])"
              >
                {{menuList[1].title}}
              </div>
              <div
                v-for="(item,index) in menuList[1].children"
                style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              >
                <span
                  style="cursor: pointer;"
                  @click="toUrl(item)"
                  :title="item.title"
                >{{item.title}}</span>
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-4"
              style="margin-top: 30px;"
            >
              <div
                class="row"
                style="margin-left: 16px;"
              >
                <div class="col-xs-12 col-sm-6">
                  <img
                    src="../assets/img/bottom1.jpg"
                    alt=""
                    class="center-block"
                    width="130px"
                  >
                  <p class="text-center">{{ $t("message.i18n_10") }}</p>
                </div>
                <div class="col-xs-12 col-sm-6">
                  <img
                    src="../assets/img/bottom2.png"
                    alt=""
                    class="center-block"
                    width="130px"
                  >
                  <p class="text-center">{{ $t("message.i18n_11") }}</p>
                </div>
  
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 visible-xs">
              <div style="display: flex;width: 200px;">
                <div style="margin-left: 28px;">{{ $t("message.language") }}:</div>
                <select
                  v-model="language"
                  style="color: black;margin-left: 6px;border-radius: 4px;"
                >
                  <option value="zh-CN">中文</option>
                  <option value="en">English</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="FooterSearchthird"
        class="container-fluid"
      >
        <p class="address_tel_fax">
          <span>{{ $t("message.i18n_12") }}</span>
        </p>
        <p class="email_wx">
          <span><a
              href="http://beian.miit.gov.cn/"
              class="aHrefStyle"
            >{{ $t("message.i18n_13") }}</a></span>
          <span>{{ $t("message.i18n_13_1") }}：<a
              href="mailto:gbcadev@aliyun.com"
              class="aHrefStyle"
            >{{ $t("message.i18n_13_2") }}</a></span>
        </p>
        <p class="copy">{{ $t("message.i18n_14") }}：<a
            href="https://m.shoucq.com/pcTopage.html"
            target="_blank"
            class="aHrefStyle"
          >{{ $t("message.i18n_14_1") }}</a></p>
      </div>
    </div>
  
  </template>
  <script>
  import {
    GetCompanyBottomById,
    GetMenuList
  } from '../api/api.js'
  export default {
    name: "FooterSearchthird",
    data () {
      return {
        language: localStorage.getItem('language') || navigator.language || 'zh-CN',
        bottomMsg: {},
        menuList: []
      };
    },
    mounted () {
      this.getCompanyBottomById()
      this.getMenuList()
    },
    watch: {
      language (newVal) {
        window.location.reload()
        localStorage.setItem('language', newVal)
        this.$store.state.languageVuex = newVal
      }
    },
    methods: {
      toUrl (item) {
        if (item.type == 1) {
          this.$router.push({
            path: '/page/singlepage/' + item.id,
          })
        } else {
          // console.log(item)
          this.$router.push({
            path: item.url,
          })
          // console.log('****',item.url)
        }
      },
      getCompanyBottomById () {
        GetCompanyBottomById().then(res => {
          if (res && res.errorCode == 0) {
            this.bottomMsg = res.data
          } else {
  
          }
        })
      },
      getMenuList () {
        GetMenuList().then(res => {
          if (res && res.errorCode == 0) {
            if (this.$store.state.languageVuex == 'en') {
              let objEnglish = JSON.parse(JSON.stringify(res.data).replace(/titleEnglish/g, "enName"))
              let obj = JSON.parse(JSON.stringify(objEnglish).replace(/title/g, "zh-CN"))
              let title = JSON.parse(JSON.stringify(obj).replace(/enName/g, "title"))
              this.menuList = title
            } else {
              this.menuList = res.data
            }
          } else {
  
          }
        })
      },
    }
  };
  </script>
  <style scoped>
      a {
          text-decoration: none;
      }
      #FooterSearchthird {
          width: 100%;
          color: black;
          background: rgb(221, 221, 221);
          overflow: hidden;
          text-align: center;
      }
  
      .logo {
          width: 95px;
          height: 45px;
          margin: 50px auto 20px;
      }
  
      .title {
          font-size: 25px;
          margin-bottom: 20px;
      }
  
      .address_tel_fax {
          color: black;
          font-size: 13px;
          margin: 10px 0;
      }
  
      .email_wx {
          color: black;
          font-size: 13px;
      }
  
      .copy {
          color: black;
          font-size: 13px;
          /* margin: 50px 0 10px; */
      }
  
      .aHrefStyle {
          cursor: pointer;
          color: black;
      }
  
      @media screen and (max-width: 997px) {
          .title {
              font-size: 20px;
          }
  
          .address_tel_fax {
              font-size: 12px;
          }
  
          .email_wx {
  
              font-size: 12px;
          }
  
          .copy {
              font-size: 12px;
              margin: 30px 0 10px;
          }
      }
  </style>
  


// WEBPACK FOOTER //
// src/components/FooterSearchthird.vue